import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export const Legend = ({
  required,
  className,
  ...extraProps
}) =>
/*#__PURE__*/
// $FlowFixMe[cannot-spread-inexact]
_jsx("legend", {
  className: clsx({
    'label-required': required
  }, className),
  ...extraProps
});